import logo from "images/logo_with_text_background.png";
import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";

export default function TheInvitation() {
  function getTimeRemaining() {
    const target = new Date("2025-09-06T04:30:00+06:00"); // Wedding date and time in UTC+7
    const now = new Date();
    const diff = target - now;

    if (diff <= 0) {
      return null;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);

    return { days, hours, minutes };
  }

  function Countdown() {
    const [time, setTime] = useState(getTimeRemaining());

    useEffect(() => {
      const timer = setInterval(() => {
        setTime(getTimeRemaining());
      }, 1000 * 30); // update every 30 seconds

      return () => clearInterval(timer);
    }, []);

    if (!time) {
      return (
        <Typography
          align="center"
          variant="h6"
          color="secondary.main"
          sx={{ mt: 2 }}
        >
          It's Wedding Time!
        </Typography>
      );
    }

    return (
      <Typography
        align="center"
        variant="h6"
        color="secondary.main"
        sx={{ mt: 2 }}
      >
        {time.days} days, {time.hours} hours, {time.minutes} minutes to go!
      </Typography>
    );
  }

  return (
    <>
      <Typography align="center" variant="h3" color="secondary.main">
        We are excited to invite you to our wedding!
      </Typography>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img alt="Camp Somos" src={logo} style={{ width: "60%" }}></img>
      </Box>

      <Typography align="center" variant="h4" color="secondary.light">
        September 6, 2025
      </Typography>

      <Countdown />
    </>
  );
}
